export default function Variables() {
    return {
        oldestItems: [
            {
                id: 1,
                name: 'Gastos',
                schema: 'expenses',
                dataHeads: [
                    {
                        key: 'serie',
                        label: 'Nº',
                    },
                    { key: 'provider.name', label: 'Empresa' },
                    { key: 'bill_date', label: 'Fecha' },
                    { key: '', label: '' },
                ],
                data: [],
                totalItems: 0,
                class: 'one',
                isLoading: true,
            },
            {
                id: 2,
                name: 'Facturas',
                schema: 'bills',
                dataHeads: [
                    {
                        key: 'serie',
                        label: 'Nº',
                    },
                    { key: 'client_name', label: 'Cliente' },
                    { key: 'date', label: 'Fecha' },
                    { key: '', label: '' },
                ],
                data: [],
                totalItems: 0,
                class: 'one',
                isLoading: true,
            },
            {
                id: 3,
                name: 'Albaranes',
                schema: 'invoices',
                dataHeads: [
                    {
                        key: 'serie',
                        label: 'Nº',
                    },
                    { key: 'client_name', label: 'Cliente' },
                    { key: 'date', label: 'Fecha' },
                    { key: '', label: '' },
                ],
                data: [],
                totalItems: 0,
                class: 'two',
                isLoading: true,
            },
        ],
        yearsInThePast: 5,
    }
}
